import { GetPatientsOptions } from './get-patients';

export const patientKeys = {
  all: ['patients'] as const,
  lists: () => [...patientKeys.all, 'list'] as const,
  list: (filters: GetPatientsOptions) =>
    [...patientKeys.lists(), { filters }] as const,
  details: () => [...patientKeys.all, 'detail'] as const,
  detail: (pid: string) => [...patientKeys.details(), pid] as const,
  search: (pid: string, query?: string) =>
    [...patientKeys.all, 'search', { pid, query }] as const,
};
